/* eslint no-param-reassign: "off" */
import * as types from './mutation-types';

export default {
  [types.GET_ACTIVITIES_REQUEST]: state => {
    state.getActivitiesRequest = true;
    state.getActivitiesSuccess = false;
    state.getActivitiesFailed = false;
    state.getActivitiesErrors = null;
  },

  [types.GET_ACTIVITIES_SUCCESS]: (state, results) => {
    state.getActivitiesRequest = false;
    state.getActivitiesSuccess = true;
    state.getActivitiesFailed = false;
    state.getActivitiesErrors = null;
    state.activities = results;
  },

  [types.GET_ACTIVITIES_FAILURE]: (state, error) => {
    state.getActivitiesRequest = false;
    state.getActivitiesSuccess = false;
    state.getActivitiesFailed = true;
    state.getActivitiesErrors = error;
  },

  [types.DELETE_ACTIVITY_REQUEST]: state => {
    state.deleteActivityRequest = true;
    state.deleteActivitySuccess = false;
    state.deleteActivityFailed = false;
    state.deleteActivityErrors = null;
  },

  [types.DELETE_ACTIVITY_SUCCESS]: (state, id) => {
    state.deleteActivityRequest = false;
    state.deleteActivitySuccess = true;
    state.deleteActivityFailed = false;
    state.deleteActivityErrors = null;

    state.activities.splice(state.activities.findIndex(x => x.id === id), 1);
  },

  [types.DELETE_ACTIVITY_FAILURE]: (state, error) => {
    state.deleteActivityRequest = false;
    state.deleteActivitySuccess = false;
    state.deleteActivityFailed = true;
    state.deleteActivityErrors = error;
  },

  [types.START_ACTIVITY_POLLING]: (state, interval) => {
    state.activityPollInterval = interval;
  },

  [types.STOP_ACTIVITY_POLLING]: state => {
    state.activityPollInterval = null;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/activities/mutations.js